import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Link } from "react-router-dom/cjs/react-router-dom"
import { Card } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import AreasTable from "../../components/tables/AreasTable"
import MaterialIcon from "../../components/elements/MaterialIcon"
import { getAreasAction } from "../../actions/areasActions"

class AreaPage extends Component {

	componentDidMount() {
		this.props.getAreasAction({ pageSize: 15, sorted: null, filters: [], page: 1 })
	}

	render() {
		return (
			<div>
				<div className="top-actions-row">
					<Link to="areas/create" className="btn btn-primary btn-sm btn-roundet btn-dropshadow mr-2"><MaterialIcon icon="add" /><FormattedMessage id="buttons.new_area" /></Link>
					<Link to="areas/skill/create" className="btn btn-primary btn-sm btn-roundet btn-dropshadow"><MaterialIcon icon="add" /><FormattedMessage id="buttons.new_skill" /></Link>

				</div>
				<Card className="fadeInLoadUp" >
					<Card.Body>
						<AreasTable />
					</Card.Body>
				</Card>
			</div>
		)
	}
}

AreaPage.propTypes = {
	getAreasAction: PropTypes.func.isRequired,
	clients: PropTypes.shape({
		isLoading: PropTypes.bool,
		isExporting: PropTypes.bool,
		hasError: PropTypes.bool,
		filters: PropTypes.arrayOf(PropTypes.object),
		meta: PropTypes.shape({
			pagination: PropTypes.shape({
				current_page: PropTypes.number.isRequired
			})
		})
	}).isRequired
}

const mapStateToProps = (state) => ({
	clients: state.clients
})

export default connect(mapStateToProps, { getAreasAction })(AreaPage)
